import { EventType } from '../../../../services/interfaces';

export const noMinuteEvents: EventType[] = [
  EventType.START_PHASE,
  EventType.END_PHASE,
  EventType.PAUSE,
  EventType.RESUME,
  EventType.CHANGE_PHASE,
  EventType.INJURY_TIME,
];
